import { render } from "./Settings.vue?vue&type=template&id=5eccccb8&scoped=true"
import script from "./Settings.vue?vue&type=script&lang=js"
export * from "./Settings.vue?vue&type=script&lang=js"

import "./Settings.vue?vue&type=style&index=0&id=5eccccb8&lang=postcss&scoped=true"
script.render = render
script.__scopeId = "data-v-5eccccb8"

export default script